export default "__VITE_ASSET__D6QMmx1g__"